import { render, staticRenderFns } from "./DotIcon.vue?vue&type=template&id=02fffc96&scoped=true"
var script = {}
import style0 from "./DotIcon.vue?vue&type=style&index=0&id=02fffc96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fffc96",
  null
  
)

export default component.exports